<template>
    <section>
        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

        <div class="row">
            <div class="col" v-for="(item, index) in customerList.filter((value, index) => $AppUtility.renderByPage(this.activePage, this.pageSize, index))" :key="index">
                <div class="board mb-4">
                    <div class="content">
                        <b-icon icon="file-text" class="icon-decoration"></b-icon>

                        <div class="license">
                            <label>ทะเบียนรถ</label>
                            <span>{{ item.licensePlate }}</span>
                        </div>

                        <div class="car">
                            <b-icon icon="minecart-loaded"></b-icon> {{ item.car }}
                        </div>

                        <div class="info">
                            <div class="item">
                                <label><b-icon icon="clock"></b-icon> บริการครั้งล่าสุด</label>
                                <span>{{ item.latestServiceDate }}</span>
                            </div>
                            <div class="item">
                                <label><b-icon icon="person"></b-icon> บิลล่าสุดโดย</label>
                                <span>{{ item.customerName }}</span>
                            </div>
                        </div>

                        <router-link :to="[ '/customer/', item.key ].join('')" class="btn btn-block btn-grey-outline">ดูรายละเอียด</router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="no-data" v-if="!isSearch">
            <b-icon icon="search"></b-icon>
            <span>โปรดพิมพ์ข้อมูลลูกค้าที่ต้องการจะค้นหา</span>
        </div>

        <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="customerList.length" class="mt-4"></paging>
    </section>
</template>

<script>
import DBCustomer from '@/database/Customer';

export default {
    data() {
        return {
            customerList: [],
            isSearch: false,
            isLoading: false,
            activePage: 1,
            pageSize: 18
        }
    },
    props: {
        customerFilter: Object
    },
    methods: {
        filterResult(result) {
            if (this.customerFilter.keyword) {
                result = result.filter(x => x.customerFirstName?.toLowerCase().indexOf(this.customerFilter.keyword.toLowerCase()) > -1 
                                        || x.customerLastName?.toLowerCase().indexOf(this.customerFilter.keyword.toLowerCase()) > -1
                                        || x.customerTel?.toLowerCase().indexOf(this.customerFilter.keyword.toLowerCase()) > -1
                                        || x.carBrand?.toLowerCase().indexOf(this.customerFilter.keyword.toLowerCase()) > -1
                                        || x.carModel?.toLowerCase().indexOf(this.customerFilter.keyword.toLowerCase()) > -1
                                        || x.carYearSerie?.toLowerCase().indexOf(this.customerFilter.keyword.toLowerCase()) > -1
                                        || x.licensePlate?.toLowerCase().indexOf(this.customerFilter.keyword.toLowerCase()) > -1)
            }

            return result;
        },
        async loadCustomerList() {
            this.isSearch = true;
            this.isLoading = true;
            this.customerList = [];
            const result = await DBCustomer.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Map and Place into the Object
                this.customerList = this.mapViewData(result.content);
            }

            this.isLoading = false;
        },
        mapViewData(content) {
            const data = [];

             content.forEach((item) => {
                data.push({
                    key: item.key,
                    licensePlate: item.licensePlate,
                    car: [ item.carBrand, item.carModel, item.carYearSerie ].filter(Boolean).join(' '),
                    latestServiceDate: item.latestServiceDate ? this.$AppUtility.displayTimeFormat(item.latestServiceDate) : 'ยังไม่เคยเข้ารับบริการ',
                    customerName: [ item.customerFirstName, item.customerLastName ].join(' ') 
                });
             });

            return data;
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.row {
    .col {
        flex: 0 0 33%;
        max-width: 33%;

        @media only screen and (max-width: $screenExtraLarge) {
            flex: 0 0 50%;
            max-width: 50%;
        }

        @media only screen and (max-width: $screenSmall) {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }
}

.no-data {
    border: 1px dashed $textLightestColor;
}

.icon-decoration {
    position: absolute;
    top: 20px;
    left: 20px;
    color: $textMainColor;
    font-size: 32px;
    opacity: 0.1;
}

.license {
    text-align: center;
    margin-bottom: 20px;

    label {
        display: block;
        font-size: 12px;
        opacity: 0.65;
        margin: 0;
    }

    span {
        display: block;
        font-size: 32px;
        font-weight: bold;
        font-style: italic;
        line-height: 36px;
    }

    &:after {
        content: " ";
        display: block;
        margin: 20px auto 0;
        width: 80px;
        height: 1px;
        background: $textMainColor;
        opacity: 0.3;
    }
}

.car {
    font-size: 13px;
    opacity: 0.7;
    text-align: center;

    .bi {
        font-size: 16px;
        margin-right: 10px;
    }
}

.info {
    padding: 40px 0;
    font-size: 12px;

    .item {
        margin: 3px 0;

        label {
            opacity: 0.5;
            margin: 0;
            width: 110px;

            .bi {
                margin-right: 5px;
            }
        }

        span {
            white-space: nowrap;
        }
    }
}
</style>